import React from 'react';
import './ConfirmationDetailsTable.css';
import{moneyFormatter} from '../library/FormatUtil';


function ConfirmationDetailsTable(props) {
  return (
    <>

            <tbody>
              {props.confirmationData?.chargeList?.map((item) => (
                <tr key={item.epayChargeId}>
                  <td className='td-confirm-description'>{item.chargeDescription}</td>
                  <td className='td-charges-amount text-end pr-2'>
                    {moneyFormatter.format(item.chargeAmount)}
                  </td>
                  <td></td>
                </tr>
              ))}
            </tbody>
           
    </>
  )
}

export default ConfirmationDetailsTable
